import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('recovery_ai.settings.escalation_contacts.rationale')

// Stable ids for the three rationale bullets — used as the list `key` (never the
// array index, per conventions) and to resolve each bullet's i18n copy.
const RATIONALE_KEYS = ['scope', 'suspicious', 'food_safety'] as const

// Indentation of the bulleted list (extracted so the magic number isn't an
// inline literal in css()).
const LIST_PADDING_LEFT = '20px'

// A little air between the three bullets so the list doesn't read as a solid
// block. Applied to every item but the first via a :not(:first-child) selector
// (no mt-* utility equivalent), so it stays a named constant and the list keeps
// flush edges.
const LIST_ITEM_GAP = '8px'

// Static, presentational rationale block shown atop the Escalation Contacts pane
// (AI-32 / U1): the "Your AI agent escalates when:" heading + three bullets. No
// data fetching and no interactive controls.
const EscalationRationaleList = () => {
  const [css] = useStyletron()
  return (
    <div>
      <Text.BodyText3 bold>{t('heading')}</Text.BodyText3>
      <ul
        className={`mt-xxs ${css({
          paddingLeft: LIST_PADDING_LEFT,
          marginBottom: 0,
        })}`}
      >
        {RATIONALE_KEYS.map(key => (
          <li
            key={key}
            className={css({
              ':not(:first-child)': { marginTop: LIST_ITEM_GAP },
            })}
          >
            <Text.BodyText3 color="grey70">{t(key)}</Text.BodyText3>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default EscalationRationaleList
